import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { inputStyles, labelStyles } from './styles';
import { BaseCheckboxAndRadioButton } from '../BaseCheckboxAndRadioButton';

var RadioButton = props => React.createElement(BaseCheckboxAndRadioButton, _extends({}, props, {
  inputStyleOverrides: [inputStyles, props.inputStyleOverrides],
  labelStyleOverrides: [labelStyles, props.labelStyleOverrides],
  type: "radio"
}));

export { RadioButton };